import { addMonths, endOfMonth, startOfMonth } from 'date-fns';

/**
 * The period the overview opens on: two months back through one month ahead, whole months.
 *
 * Shared with the quality monitor tile (feature #2004) on purpose. The tile counts the requests
 * still awaiting processing over exactly this period, so a tile showing N is a promise that
 * clicking it opens an overview holding those same N rows. Two clocks would drift apart the moment
 * either default was changed.
 */
export const getDefaultHoursPayOutPeriod = (): [Date, Date] => {
  const today = new Date();
  return [startOfMonth(addMonths(today, -2)), endOfMonth(addMonths(today, 1))];
};
